import { LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import moment from 'moment';
import { memo, useCallback } from 'react';

import type { TimeSidebarType } from '@app/components/Calendars/components/TimeSidebar/types';
import { emptyFn } from '@app/constants';
import { ONE_TIME_CELL_PIXELS } from '@app/shared/calendar';

import '@app/components/Calendars/components/TimeSidebar/styles/TimeSidebar.desktop.scss';

export const TimeSidebar: TimeSidebarType = memo(
  ({
    times,
    smallestTimeValue = null,
    columnRef = null,
    onScroll = emptyFn,
    side = 'left',
    className = '',
    showArrowButton = false,
  }) => {
    const ArrowButton =
      side === 'left' ? LeftCircleOutlined : RightCircleOutlined;

    const handleScrollClick = useCallback(() => {
      onScroll();
    }, [onScroll]);
    return (
      <>
        <Row className={className}>
          {showArrowButton && (
            <Col className="icons">
              <ArrowButton
                onClick={handleScrollClick}
                className="arrow-button"
              />
            </Col>
          )}
          {times.map((time) => {
            const [hour, minute] = time.split(':');
            const isSmallestTime =
              moment(smallestTimeValue, 'HH:mm').format('HH') === hour;
            return (
              <Col
                className="time-cell"
                style={{ height: ONE_TIME_CELL_PIXELS }}
                key={time}
                aria-valuetext={time}
                ref={isSmallestTime ? columnRef : null}
              >
                {minute === '00' ? (
                  <>
                    {hour} <sup>{minute}</sup>
                  </>
                ) : (
                  minute === '30' && minute
                )}
              </Col>
            );
          })}
        </Row>
      </>
    );
  },
  (prevProps, nextProps) =>
    prevProps.times.length === nextProps.times.length &&
    prevProps.times.every((time, index) => time === nextProps.times[index]) &&
    prevProps.smallestTimeValue === nextProps.smallestTimeValue
);
